import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectIsOwnerAccount, sidebarTheme } from '@cloud/shared';

import { unlockScroll } from '@ovpn-ui/utils';
import { Navigation, useSidebar } from '@ovpn-ui/navigation';

import ProjectLogo from './ProjectLogo';
import { AppSidebarFooter } from './SidebarFooter';
import { SingleTenantBanner, TenantSwitcher } from './TenantSwitcher';
import useMenuLinks from './useMenuLinks';
import { useSidebarAnalytics } from './useSidebarAnalytics';

export function AppNavigation() {
    const menuLinks = useMenuLinks();
    const isMultiTenant = useSelector(selectIsOwnerAccount);

    const isMobileSideberOpen = useSidebar();

    const { handleSidebarItemClick } = useSidebarAnalytics();

    useEffect(() => {
        if (!isMobileSideberOpen) {
            unlockScroll();
        }
    }, [isMobileSideberOpen]);

    return (
        <Navigation
            onItemClick={handleSidebarItemClick}
            links={menuLinks}
            theme={sidebarTheme}
            TenantSwitcher={isMultiTenant ? TenantSwitcher : SingleTenantBanner}
            FooterComponent={AppSidebarFooter}
            logo={<ProjectLogo.Default />}
            logoCollapsed={<ProjectLogo.Collapsed />}
        />
    );
}
